import { render, staticRenderFns } from "./AgregaDocumentoPersonal.vue?vue&type=template&id=47ee54cd"
import script from "./AgregaDocumentoPersonal.vue?vue&type=script&lang=js"
export * from "./AgregaDocumentoPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports